var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_563_7477",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.359048 9.09714C1.96192 2.6685 8.47382 -1.24384 14.9039 0.359262C21.3314 1.96195 25.2441 8.47352 23.6406 14.9016C22.0384 21.331 15.5265 25.2436 9.09838 23.6409C2.66873 22.0382 -1.24382 15.526 0.359224 9.09702L0.359105 9.09714L0.359048 9.09714Z",
    fill: "#79C62B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_563_7477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.359048 9.09714C1.96192 2.6685 8.47382 -1.24384 14.9039 0.359262C21.3314 1.96195 25.2441 8.47352 23.6406 14.9016C22.0384 21.331 15.5265 25.2436 9.09838 23.6409C2.66873 22.0382 -1.24382 15.526 0.359224 9.09702L0.359105 9.09714L0.359048 9.09714Z",
    fill: "#012A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.24056 2.49704C-7.63769 -3.93159 -1.12579 -7.84393 5.30433 -6.24084C11.7318 -4.63815 15.6445 1.87342 14.041 8.30153C12.4388 14.7309 5.9269 18.6435 -0.501226 17.0408C-6.93088 15.4381 -10.8434 8.92585 -9.24039 2.49692L-9.2405 2.49704L-9.24056 2.49704Z",
    fill: "#748094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95866 4.29734C11.5615 -2.1313 18.0734 -6.04364 24.5036 -4.44054C30.931 -2.83786 34.8438 3.67372 33.2402 10.1018C31.638 16.5312 25.1261 20.4438 18.698 18.8411C12.2683 17.2384 8.35579 10.7261 9.95883 4.29722L9.95871 4.29734L9.95866 4.29734Z",
    fill: "#FF495C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar2.70024f795eb05c0e4339c8f94eb7a283.svg";
export { ForwardRef as ReactComponent };